import { Component, OnInit, Input } from '@angular/core';
import { GPSFrame } from 'src/app/vehicles/model/gps-frame';
import { TreeControlNode } from 'src/app/shared/model/tree-control-node';
import { MatDialog } from '@angular/material/dialog';
import { DevicesDialogComponent } from '../devices/devices-dialog.component';
import { MapEventService } from 'src/app/map/service/map-event.service';

@Component({
  selector: 'app-frame-tree-item',
  templateUrl: './frame-tree-item.component.html',
  styleUrls: ['./frame-tree-item.component.scss']
})
export class FrameTreeItemComponent implements OnInit {

  @Input()
  node: TreeControlNode<GPSFrame>;

  constructor(private dialog: MatDialog, private mapEventService: MapEventService) { }

  ngOnInit(): void { }

  showDevicesStatuses(): void {
    this.dialog.open(DevicesDialogComponent, {
      data: {
        sideNumber: this.node.data.vehicle.sideNumber
      }
    });
  }

  showOnMap(): void {
    this.mapEventService.centerOnMap(this.node.data);
  }

}
